import React, {useContext, useEffect} from "react";
import AuthContainer from "../../containers/AuthContainer";
import {ContentAuth, CardAuth, TitleAuth, TextAuth, SectionSeparator} from "./components/AuthStyles";
import {GlobalContext} from "../../context/GlobalContext";
import styled from "styled-components";
import {Content} from "../../styles/GlobalStyles";
import {ReactComponent as UserIcon} from "../../assets/icons/user.svg";
import Color from "../../assets/Colors";
import {ButtonSubmit} from "../../components/footer/styles";
import Offer from "../../styles/Offer";
import {useHistory} from "react-router-dom";
import {TitleSection} from "../../styles/HeadView";
import {TypeTitle} from "../../styles/Products";
import {HistoryCourses} from "../../services/GeneralServices";
import {LoadComponet} from "../../components/loaders/Loader";

export default function ProfileView() {
   const {userData, doLogout, getMyCourses, myCoursesList} = useContext(GlobalContext);
   let history = useHistory();
   const {sessionStarted} = useContext(GlobalContext);

   useEffect(() => {
      if (!sessionStarted) {
         // leer cambios en el status de la sesión y redireccionar al perfil
         history.replace("/iniciar_sesion", {prev: "perfil"});
      }
   }, [sessionStarted]);

   useEffect(() => {
      getMyCourses();
   }, [userData]);

   function logout() {
      doLogout();
      history.replace("/");
   }

   return (
      <AuthContainer>
         <Content>
            <ContentAuth direction="column">
               <CardProfile>
                  {/* <UserIcon width="6em" height="7em" fill={Color.secondary} /> */}
                  <IconProfile src={require("../../assets/icons/perfil_icon.png")} alt="profile" className="iconProfile" />
                  <TitleProfile>
                     {userData.userName} {userData.userName}
                  </TitleProfile>
                  <CenterContent className="line">
                     <TextAuth>{userData.age} años</TextAuth>
                     <TextAuth>{userData.workplace}</TextAuth>
                  </CenterContent>
                  <CenterContent>
                     <ButtonAction
                        onClick={() => {
                           history.push("/editar_perfil");
                        }}
                     >
                        <img src={require("../../assets/icons/contact.png")} alt="edit" className="icon left" />
                        <TextProfile as="span" className="button">
                           Editar perfil
                        </TextProfile>
                     </ButtonAction>
                     <ButtonAction onClick={logout}>
                        <TextProfile as="span" className="button">
                           Cerrar sesión
                        </TextProfile>
                        <img src={require("../../assets/icons/logout.png")} alt="logout" className="icon right" />
                     </ButtonAction>
                  </CenterContent>
                  {userData.industryExperience && (
                     <>
                        <CenterContent className="min">
                           <div className="row">
                              <TextProfile className="title">CENTRO DE TRABAJO</TextProfile>
                              <TextProfile className="text">{userData.workplace}</TextProfile>
                           </div>
                           <div className="row">
                              <TextProfile className="title">Experiencia</TextProfile>
                              <TextProfile className="text">{userData.expYears}</TextProfile>
                           </div>
                        </CenterContent>
                        <CenterContent className="min">
                           <div className="row">
                              <TextProfile className="title">Puesto</TextProfile>
                              <TextProfile className="text">{userData.position}</TextProfile>
                           </div>
                           <div className="row">
                              {userData.certification && (
                                 <>
                                    <TextProfile className="title">Certificación</TextProfile>
                                    <TextProfile className="text">{userData.certification}</TextProfile>
                                 </>
                              )}
                           </div>
                        </CenterContent>
                     </>
                  )}
               </CardProfile>
               <SectionSeparator />
               <div style={{width: "100%"}}>
                  <TitleSection>
                     <img src={require("../../assets/icons/historial_icon.png")} alt="offer" className="icon" />
                     <TypeTitle className="titleSection" color={Color.primary}>
                        Historial de cursos
                     </TypeTitle>
                  </TitleSection>
               </div>
               {myCoursesList.isLoading ? (
                  <LoadComponet />
               ) : myCoursesList.offer.length === 0 ? (
                  <div className="row">
                     <TextProfile className="title">No has tomado algún curso.</TextProfile>
                  </div>
               ) : (
                  <Content>
                     <Offer data={myCoursesList.offer} description={false} pathName="cursos_esenciales" />
                  </Content>
               )}
            </ContentAuth>
         </Content>
      </AuthContainer>
   );
}

const TitleProfile = styled(TitleAuth)`
   text-transform: uppercase;
   margin: 1em 0;
   // font-size: 1.8em;}
`;
const TextProfile = styled(TextAuth)`
   &.text {
      font-weight: 400;
      color: ${Color.primary};
   }
   &.title {
      text-transform: uppercase;
   }
   @media screen and (max-width: 500px) {
      &.title {
         font-size: 0.75em;
         margin-bottom: 3px;
      }
   }
`;

const CardProfile = styled(CardAuth)`
   padding-top: 5em;
   padding-bottom: 2em;
   flex-direction: column;
   width: 40%;

   @media screen and (max-width: 800px) {
      padding-top: 2em;
      padding-bottom: 0;
      width: 70%;
   }

   @media screen and (max-width: 500px) {
      padding-top: 6em;
      width: 100%;
   }
`;

const IconProfile = styled.img`
   @media screen and (max-width: 800px) {
      height: 5em;
      object-fit: cover;
   }
   @media screen and (max-width: 500px) {
      height: 4em;
   }
`;

const CenterContent = styled.div`
   display: flex;
   justify-content: center;
   aign-items: center;
   width: 100%;
   margin-bottom: 2em;

   &.min {
      width: 80%;
   }

   @media screen and (max-width: 500px) {
      &.min {
         width: 100%;
      }
   }

   & .row {
      width: 50%;
   }

   &.line {
      & ${TextAuth} {
         padding: 0.5em 1em;
         &:first-child {
            position: relative;
            &:after {
               content: "|";
               position: absolute;
               top: 25%;
               right: 0;
               height: 50%;
            }
            &:before {
               content: "";
               position: absolute;
               top: -0.5em;
               right: -0.5em;
               width: 1em;
               border-bottom: 1px solid ${Color.primary};
            }
         }
      }
   }

   @media screen and (max-widht: 800px) {
      &.min {
         width: 100%;
      }
   }
`;
const ButtonAction = styled(ButtonSubmit)`
   border: 1px inset ${Color.textColor};
   color: ${Color.primary};
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 1em 1.5em;
   font-weight: 400;
   font-size: 1.3em;
   margin-top: 0.5em;
   margin-bottom: 1.5em;

   & ${TextProfile} {
      font-weight: 400;
      color: ${Color.primary};
      font-size: 0.9em;
      text-transform: uppercase;
   }

   &:hover {
      & ${TextProfile} {
         color: white;
      }
   }

   & .icon {
      width: 1em;
      height: 1em;

      &.left {
         margin-right: 0.5em;
      }
      &.right {
         margin-left: 0.5em;
      }
   }

   @media screen and (max-width: 1600px) {
      padding: 0.9em 1em;

      font-size: 0.9em;
   }

   @media screen and (max-width: 500px) {
      & ${TextProfile} {
         font-size: 0.8em;
      }

      & .icon {
         width: 0.8em;
         height: 0.8em;

         &.left {
            margin-right: 0.4em;
         }
         &.right {
            margin-left: 0.4em;
         }
      }
   }
`;
